import { Link } from "react-router-dom"
import type { PaperCard as PaperCardT } from "@/types/api"
import { formatRelative } from "@/lib/utils"
import { BookmarkButton } from "@/components/papers/BookmarkButton"

export function PaperCardItem({ paper }: { paper: PaperCardT }) {
  const title = paper.title_ko || paper.title_en
  return (
    <article className="rounded-lg border border-border bg-card p-5 transition-shadow hover:shadow-sm">
      <div className="mb-2 flex flex-wrap items-center gap-2 text-xs text-muted-foreground">
        <span>{formatRelative(paper.published_at)}</span>
        <span>·</span>
        <span>{paper.primary_category}</span>
        {paper.tags.slice(0, 3).map((t) => (
          <span key={t} className="rounded-md bg-secondary px-2 py-0.5 text-secondary-foreground">
            {t}
          </span>
        ))}
        {paper.score?.final !== undefined && (
          <span className="ml-auto rounded-md bg-primary/10 px-2 py-0.5 text-primary">
            ⚡ {paper.score.final.toFixed(2)}
          </span>
        )}
        <BookmarkButton paperId={paper.id} />
      </div>
      <h2 className="mb-1 text-base font-semibold leading-snug">
        <Link to={`/papers/${paper.id}`} className="hover:text-primary">
          {title}
        </Link>
      </h2>
      {paper.tldr_ko && (
        <p className="mb-2 text-sm text-foreground/80">{paper.tldr_ko}</p>
      )}
      <div className="flex flex-wrap gap-3 text-xs text-muted-foreground">
        {paper.arxiv_id && <span>arXiv:{paper.arxiv_id}</span>}
        {paper.signals.hf_upvotes > 0 && <span>🤗 {paper.signals.hf_upvotes}</span>}
        {paper.signals.citation_count > 0 && <span>📊 {paper.signals.citation_count}</span>}
        {paper.code_url && (
          <a className="text-primary hover:underline" href={paper.code_url} target="_blank" rel="noreferrer">
            code
          </a>
        )}
      </div>
    </article>
  )
}
